// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableTemplateWithoutStoreAttribute_TableTemplateWithoutStoreAttribute__titleContainer__U9dDl {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #def3db;
}

.TableTemplateWithoutStoreAttribute_TableTemplateWithoutStoreAttribute__titleFirst__vj2LH {
  width: 29px;
  font-family: Raleway;
  text-transform: none;
  font-feature-settings: "lnum";
  display: table-cell;
  vertical-align: inherit;
  text-align: left;
  padding: 16px;
  color: rgba(0, 0, 0, 0.87);
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
}

.TableTemplateWithoutStoreAttribute_TableTemplateWithoutStoreAttribute__titleSecond__Yk7\\+r {
  width: 100%;
  font-family: Raleway;
  text-transform: none;
  font-feature-settings: "lnum";
  display: table-cell;
  vertical-align: inherit;
  text-align: left;
  padding: 16px;
  color: rgba(0, 0, 0, 0.87);
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
}

.TableTemplateWithoutStoreAttribute_TableTemplateWithoutStoreAttribute__titleThird__NzUW4 {
  font-family: Raleway;
  text-transform: none;
  font-feature-settings: "lnum";
  display: table-cell;
  vertical-align: inherit;
  text-align: left;
  color: rgba(0, 0, 0, 0.87);
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
}
.TableTemplateWithoutStoreAttribute_TableTemplateWithoutStoreAttribute__titleThird__NzUW4 p {
  width: 29px;
  padding: 16px;
  margin: 0;
}

.TableTemplateWithoutStoreAttribute_TableTemplateWithoutStoreAttribute__titleFourth__-iK\\+- p {
  width: 40px;
  padding: 8px 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/Templates/TableTemplateWithoutStoreAttribute.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,mBAAA;EACA,gCAAA;AADJ;;AAGA;EACI,WAAA;EACA,oBAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAAJ;;AAEA;EACI,WAAA;EACA,oBAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AACA;EACI,oBAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAEJ;AADI;EACI,WAAA;EACA,aAAA;EACA,SAAA;AAGR;;AAEI;EACI,WAAA;EACA,iBAAA;AACR","sourcesContent":["@import '@/constants/colors';\n\n.TableTemplateWithoutStoreAttribute__titleContainer {\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid $light-gray;\n}\n.TableTemplateWithoutStoreAttribute__titleFirst {\n    width: 29px;\n    font-family: Raleway;\n    text-transform: none;\n    font-feature-settings: \"lnum\";\n    display: table-cell;\n    vertical-align: inherit;\n    text-align: left;\n    padding: 16px;\n    color: rgba(0, 0, 0, 0.87);\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 16px;\n}\n.TableTemplateWithoutStoreAttribute__titleSecond {\n    width: 100%;\n    font-family: Raleway;\n    text-transform: none;\n    font-feature-settings: \"lnum\";\n    display: table-cell;\n    vertical-align: inherit;\n    text-align: left;\n    padding: 16px;\n    color: rgba(0, 0, 0, 0.87);\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 16px;\n}\n.TableTemplateWithoutStoreAttribute__titleThird {\n    font-family: Raleway;\n    text-transform: none;\n    font-feature-settings: \"lnum\";\n    display: table-cell;\n    vertical-align: inherit;\n    text-align: left;\n    color: rgba(0, 0, 0, 0.87);\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 16px;\n    p {\n        width: 29px;\n        padding: 16px;\n        margin: 0;\n        \n    }\n}\n.TableTemplateWithoutStoreAttribute__titleFourth {\n    p {\n        width: 40px;\n        padding: 8px 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TableTemplateWithoutStoreAttribute__titleContainer": `TableTemplateWithoutStoreAttribute_TableTemplateWithoutStoreAttribute__titleContainer__U9dDl`,
	"TableTemplateWithoutStoreAttribute__titleFirst": `TableTemplateWithoutStoreAttribute_TableTemplateWithoutStoreAttribute__titleFirst__vj2LH`,
	"TableTemplateWithoutStoreAttribute__titleSecond": `TableTemplateWithoutStoreAttribute_TableTemplateWithoutStoreAttribute__titleSecond__Yk7+r`,
	"TableTemplateWithoutStoreAttribute__titleThird": `TableTemplateWithoutStoreAttribute_TableTemplateWithoutStoreAttribute__titleThird__NzUW4`,
	"TableTemplateWithoutStoreAttribute__titleFourth": `TableTemplateWithoutStoreAttribute_TableTemplateWithoutStoreAttribute__titleFourth__-iK+-`
};
export default ___CSS_LOADER_EXPORT___;
